import {combineReducers, Reducer as ReduxReducer} from 'redux';

import {BenchlingAction} from 'redux-stores/Action';

type Reducer<S> = ReduxReducer<S, BenchlingAction>;
type SubReducers<S> = {[k in keyof S]: Reducer<S[k]>};

/**
 * Benchling-specific combineReducers with the same contract but two improvements:
 *
 * - It lazily calls the underlying combineReducers, so the reducer sanity check happens on first
 *   invocation rather than immediately. That means we don't need to worry about reducers running
 *   before import has finished.
 * - It has a Benchling-specific TypeScript type that's a little more precise than the built-in
 *   combineReducers.
 *
 * This is a drop-in replacement for combineReducers and should always be used instead.
 */
export default function combineBenchlingReducers<S extends {}>(reducers: SubReducers<S>): Reducer<S> {
  let combinedReducer: Reducer<S> | null = null;
  return function lazyCombinedReducer(state: S, action: BenchlingAction): S {
    if (!combinedReducer) {
      // eslint-disable-next-line no-restricted-syntax
      combinedReducer = combineReducers(reducers) as Reducer<S>;
    }
    return combinedReducer(state, action);
  };
}
